import { render, staticRenderFns } from "./CollectionAddCaseModal.vue?vue&type=template&id=c0397404&"
import script from "./CollectionAddCaseModal.vue?vue&type=script&lang=js&"
export * from "./CollectionAddCaseModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAddCaseModal.vue?vue&type=style&index=0&id=c0397404&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports